import React, { forwardRef, useEffect, useState, useImperativeHandle } from 'react'
import moment from 'moment'
import DatePicker from "react-datepicker";
import { Button, Switch } from 'antd';

import firebase from "../../../../Firebase/firebase"
import './SimulatorForms.css'
import apolloclient from "../../../../apollo_client";
import ConductSimulator from '../ConductSimulator/ConductSimulator'
import Loading from './../../../../assets/images/loading.gif'
import { Register, simformQueryList, Sim_type_location, simulator_form_dropdown, discardstc_record, updateStcrecord, stcrecord_data, stcMutation, stcrecord, simformQuery, Header_Mutation, traineeSelect, Sim_type, Sim_location_type, traineeDropdown } from '../SimulatorQuery/SimulatorFormQuery'
import SimFormSections from '../SimFormSection/SimFormSections'
import { useIndexedDB } from 'react-indexed-db';
import { initDB } from 'react-indexed-db';
const SimulatorForm = forwardRef((props, ref) => {
    const [loading, setloading] = useState(true)
    const [startdate, setstartDate] = useState(new Date().setFullYear(new Date().getFullYear() - 1));
    const [enddate, setenddate] = useState(new Date())
    const [search, setsearch] = useState('');
    const [ispaused, setpaused] = useState(true);
    const [users, setusers] = useState({});
    const [userDetails, setUserDetails] = useState({})
    const [simformlistdata, setsimformlistdate] = useState([]);
    const [addnew, setAddNew] = useState(false);
    const [editnew, setEditNew] = useState(false);
    const [location, setLocation] = useState([])
    const [simFormMap, setsimFormMap] = useState([])
    const [trainessMap, settrainessMap] = useState([])
    const { getAll: GetAllSfrid } = useIndexedDB('sfrid');
    const { getAll: GetAllSTC } = useIndexedDB('stcid');
    const [index, setindex] = useState(0)
    const [simformdata, setsimformdata] = useState({})
    useEffect(() => {

        var connection = navigator.onLine;
        if (connection) {
            firebase.auth().onAuthStateChanged(async user => {
                if (user) {
                    setusers({
                        user: user.uid
                    })
                    apolloclient.query({
                        query: Register,
                        variables: { id: user.uid }
                    }).then((responsedetails) => {
                        setUserDetails(responsedetails.data.aatmsv4_register[0]);
                        apolloclient.query({
                            query: simulator_form_dropdown,
                            variables: {
                                id: user.uid
                            }
                        }).then(simformlists => {
                            setsimFormMap(simformlists.data.aatmsv4_smap)
                        })
                        apolloclient.query(
                            {
                                query: Sim_type_location,
                                variables: {
                                    clientsid: responsedetails.data.aatmsv4_register[0].clientsid,
                                    fleetsid: responsedetails.data.aatmsv4_register[0].fleetsid
                                }
                            }
                        ).then(locations => {
                            setLocation(locations.data.aatmsv4_sims);
                        })
                        apolloclient.query({
                            query: traineeDropdown,
                            variables: {
                                id: responsedetails.data.aatmsv4_register[0].clientsid,
                                fleetid: responsedetails.data.aatmsv4_register[0].fleetsid
                            }
                        }).then(traineesdata => {
                            settrainessMap(traineesdata.data.aatmsv4_crews)

                        })
                    })
                }
            })
        }
    }, [])
    function intialloading() {
        console.log("Updating Form List")
        let start = moment(startdate).format('YYYY-MM-DD');
        let end = moment(enddate).format('YYYY-MM-DD');
        let resultdata = [];
        setloading(false);
        GetAllSfrid().then(sfriddata => {
            sfriddata.forEach(sfridresponse => {
                if (sfridresponse.date >= start && sfridresponse.date <= end) {
                    let data = { ...sfridresponse };
                    resultdata.push(data)
                }
            })
            console.log(resultdata)
            setsimformlistdate(resultdata);

        });
    }
    useEffect(() => {
        // apolloclient.query(
        //     {
        //         query: simformQueryList,
        //         variables: {
        //             preview: ispaused,
        //             clentsid: userDetails.clientsid,
        //             trainerid: String(users),
        //             date1: moment(startdate).format('yyyy/MM/DD'),
        //             date2: moment(enddate).format('yyyy/MM/DD')
        //         }
        //     }).then(response => {
        //         console.log(response)
        //         setsimformlistdate(response.data?.aatmsv4_simformrecords);
        //         setloading(false)
        //     });
        intialloading();


    }, [ispaused, startdate, enddate, editnew, addnew])
    useImperativeHandle(ref, () => ({
        getLoadedData() {
            intialloading();
        }
    }));
    if (addnew && navigator.onLine) {
        return (
            <ConductSimulator setAddNew={setAddNew} userDetails={userDetails} users={users} locations={location} simFormMap={simFormMap} trainessMap={trainessMap} />
        )
    }
    if (editnew) {
        return (<SimFormSections index={index} setedit={setEditNew} startdate={startdate} enddate={enddate} simformdata={simformdata} />)
    }
    return (
        <div className="simulator-dashboard">
            <div className=" medium-margin-top category-title">Simulator Forms</div>
            { loading ?
                (< img style={{ padding: 100 }} src={loading ? Loading : null}
                    height="50%"
                    alt=""
                    width="50%"
                />) : (
                    <React.Fragment>
                        <button className="crew-button" onClick={() => setAddNew(true)}>
                            Conduct Simulator
                        </button>
                        <div className="table-body-container">
                            <div className="table-body-header">Simulator forms awaiting completion</div>
                            <div className="client-list-divider"></div>
                            <div className="table-container">
                                <div >
                                    {/* <div className="display-record">
                                        <label className="pdr10">
                                            Start Date
                                         </label>
                                        <DatePicker
                                            title="Start Date"
                                            selected={startdate}
                                            dateFormat="dd/MM/yyyy"
                                            onChange={date => { setstartDate(date); }}
                                        />
                                    </div>
                                    <div className="display-record">
                                        <label className="pdr10">End Date</label>
                                        <DatePicker
                                            name="enddate"
                                            title="End Date"
                                            selected={enddate}
                                            dateFormat="dd/MM/yyyy"
                                            onChange={date => { setenddate(date); }}
                                        />
                                    </div> */}
                                    {/* <div className="active-switch">
                                        <label className="pdr10">Paused</label>
                                        <Switch checked={ispaused} onClick={(e) => {
                                            console.log(e.target.checked)
                                            setpaused(e.target.checked);
                                        }} defaultChecked />
                                    </div> */}
                                    <div >
                                        <label className="pdr10">Search</label>
                                        <input
                                            className="simulator-search"
                                            type="text"
                                            value={search}
                                            onChange={(e) => setsearch(e.target.value)}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="table-row-container" >
                                <div >
                                    {simformlistdata && simformlistdata.length > 0 &&
                                        simformlistdata.map((data, index) => {
                                            return data?.simformname.toLowerCase().includes(search.toLowerCase()) && (
                                                <React.Fragment key={index}>
                                                    <div className={data.published ? 'green row-top-3' : 'row-top-3'}>
                                                        <div className=" items">
                                                            <div className="title">Date</div>
                                                            <div className="value">{data?.date}</div>
                                                        </div>
                                                        <div className=" items">
                                                            <div className="title">SimForm Name</div>
                                                            <div className="value"><a>{data?.simformname}</a></div>
                                                        </div>
                                                        <div className="items">
                                                            <div className="title">Trainee Rank</div>
                                                            <div className="value">{data?.traineerank}</div>
                                                        </div>

                                                        <div className="items">
                                                            <div className="title">Name</div>
                                                            <div className="value">{data?.traineename}</div>
                                                        </div>

                                                        <div className="items">
                                                            <div className="title">Result</div>
                                                            <div className="value">{data?.resulttext}</div>
                                                        </div>
                                                        <div className="">
                                                            {ispaused && !data.published && (
                                                                <div className="items">
                                                                    <div className="title">Paused</div>
                                                                    <div className="value"><Button type="primary" style={{backgroundColor:"#05A677",borderColor:"#05A677"}}  onClick={() => {
                                                                        setsimformdata(data); setEditNew(true); setindex(index);
                                                                    }}>Resume</Button></div>
                                                                </div>
                                                            )
                                                            }

                                                            {
                                                                data.published && (
                                                                    <div className="value"><Button type="primary" style={{backgroundColor:"yellow",borderColor:"yellow" ,color:"black"}} 
                                                                     >Sending</Button></div>
                                                                )
                                                            }
                                                        </div>

                                                    </div>
                                                    <br />

                                                </React.Fragment>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}
        </div >
    )
});

export default SimulatorForm
